import { Close } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Drawer,
  Grid,
  IconButton,
  styled,
  type Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";

const Trigger = styled(Button)(function () {
  return { minWidth: 0, padding: 0, width: "fit-content" };
});

/** @deprecated We are phasing out `cc-ui` */
export interface RightSidebarProps extends React.PropsWithChildren {
  label: string | ((onClick: () => void) => React.ReactNode);
  headingText: string;
  /** should the sidebar start open? */
  open?: boolean;
  onClose?: () => void;
  avatar?: {
    alt?: string;
    src?: string | null;
  };
  subtitle?: string | null;
}

/** @deprecated We are phasing out `cc-ui` */
export const RightSidebar = ({
  label,
  children,
  headingText,
  avatar,
  subtitle,
  onClose = () => {},
  ...props
}: RightSidebarProps) => {
  const [isOpen, setIsOpen] = useState(props.open);
  useEffect(() => setIsOpen(props.open), [props.open]);

  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down("md"));
  const isMedium = useMediaQuery<Theme>((theme) => theme.breakpoints.between("md", "lg"));
  const open = () => setIsOpen(true);
  const close = () => {
    setIsOpen(false);
    onClose();
  };

  return (
    <>
      {typeof label === "string" && (
        <Trigger onClick={open} variant="text">
          {label}
        </Trigger>
      )}
      {typeof label !== "string" && label(open)}
      <Drawer anchor="right" data-testid="drawer-root" onClose={close} open={isOpen} variant="temporary">
        <Grid
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "2rem",
            height: "100vh",
            padding: "1rem",
            width: isMobile ? "100vw" : isMedium ? "98vw" : "50vw",
          }}
        >
          <Grid
            borderBottom="1px solid lightgrey"
            sx={{ alignItems: "center", display: "flex", justifyContent: "space-between" }}
          >
            <Box sx={{ alignItems: "center", display: "flex", gap: "1rem" }}>
              {avatar && <Avatar src={avatar.src ?? undefined} sx={{ height: 64, width: 64 }} />}
              <Box>
                <Typography variant="h5">{headingText}</Typography>
                {subtitle && (
                  <Typography color="text.secondary" variant="body2">
                    {subtitle}
                  </Typography>
                )}
              </Box>
            </Box>
            <IconButton data-testid="close-sidebar-button" onClick={close}>
              <Close />
            </IconButton>
          </Grid>

          {children}
        </Grid>
      </Drawer>
    </>
  );
};
